import Vue from "vue";
import VueCookie from 'vue-cookies'
import VueI18n from "vue-i18n";
import locale from "./languageLoader";
const messages = locale.messages;

Vue.use(VueI18n);
Vue.use(VueCookie)

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages
});

function setLanguage(lang) {
  i18n.locale = lang;
  window.$cookies.set("lang", lang, "1y");
}

function getCurrentLanguage() {
  return i18n.locale;
}

function getLanguages() {
  const languages = [];
  const codes = Object.keys(locale.languages);
  for (let i = 0, len = codes.length; i < len; i++) {
    if (codes[i] !== "aa") {
      const lang = {
        value: codes[i],
        text: locale.languages[codes[i]]
      };
      languages.push(lang);
    }
  }
  return languages;
}

export function t(text) {
  return i18n.t(text);
}

Vue.prototype.$locale = {
  setLanguage,
  getCurrentLanguage,
  getLanguages
};

export default {
  i18n,
  setLanguage,
  getCurrentLanguage
};
